import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { AnnotationRenderer, FormFieldsBase } from './index';
import { PdfAnnotationFlag, PdfInkAnnotation, PdfPen, PdfPath } from '@syncfusion/ej2-pdf';
import { AnnotationStatus } from '../index';
import { Rect } from './../ej2-drawings/index';
/**
 * SignatureBase
 *
 * @hidden
 */
var SignatureBase = /** @class */ (function () {
    function SignatureBase(pdfViewer, pdfViewerBase) {
        this.pdfViewer = pdfViewer;
        this.pdfViewerBase = pdfViewerBase;
    }
    /**
     * @private
     * @param {string} jsonObject - jsonObject
     * @param {any} loadedDocument - loadedDocument
     * @returns {void}
     */
    SignatureBase.prototype.saveSignatureData = function (jsonObject, loadedDocument) {
        var formfields = new FormFieldsBase(this.pdfViewer, this.pdfViewerBase);
        var signatureDetails = JSON.parse(jsonObject.signatureData);
        if (!isNullOrUndefined(signatureDetails)) {
            for (var i = 0; i < signatureDetails.length; i++) {
                var pageData = signatureDetails[parseInt(i.toString(), 10)];
                // Save signature as data
                if (pageData.length > 0) {
                    for (var p = 0; p < pageData.length; p++) {
                        if (jsonObject['action'] === 'ExportAnnotations' || pageData[parseInt(p.toString(), 10)].status === AnnotationStatus.NewlyAdded) {
                            var data = pageData[parseInt(p.toString(), 10)];
                            var signatureType = Object.prototype.hasOwnProperty.call(data, 'shapeAnnotationType') && data['shapeAnnotationType'] !== null
                                ? data['shapeAnnotationType'].toString()
                                : null;
                            if (signatureType !== null && signatureType === 'SignatureText') {
                                formfields.drawFreeTextAnnotations(data, loadedDocument, true);
                            }
                            else if (signatureType !== null && signatureType === 'SignatureImage') {
                                formfields.drawImage(data, loadedDocument, true);
                            }
                            else {
                                var pageNumber = data.pageIndex;
                                var page = loadedDocument.getPage(pageNumber);
                                var rotateAngle = this.getRotateAngle(page.rotation.toString());
                                var size = page.size;
                                var pageWidth = size.width;
                                var pageHeight = size.height;
                                if (rotateAngle === 1 || rotateAngle === 3) {
                                    pageHeight = size.width;
                                    pageWidth = size.height;
                                }
                                else {
                                    pageHeight = size.height;
                                    pageWidth = size.width;
                                }
                                var bounds = JSON.parse(data.bounds);
                                bounds = this.getSignatureBounds(bounds, this.convertPointToPixel(pageHeight), this.convertPointToPixel(pageWidth), rotateAngle);
                                var stampObjects = JSON.parse(data.data);
                                var left = this.convertPixelToPoint(bounds.left);
                                var top_1 = this.convertPixelToPoint(bounds.top);
                                var width = this.convertPixelToPoint(bounds.width);
                                var height = this.convertPixelToPoint(bounds.height);
                                var opacity = data.opacity;
                                var thickness = data.thickness;
                                var strokeColor = JSON.parse(data.strokeColor);
                                var color = { r: strokeColor.r, g: strokeColor.g, b: strokeColor.b };
                                var minimumX = -1;
                                var minimumY = -1;
                                var maximumX = -1;
                                var maximumY = -1;
                                for (var p_1 = 0; p_1 < stampObjects.length; p_1++) {
                                    var value = stampObjects[parseInt(p_1.toString(), 10)];
                                    if (minimumX === -1) {
                                        minimumX = value.x;
                                        minimumY = value.y;
                                        maximumX = value.x;
                                        maximumY = value.x;
                                    }
                                    else {
                                        var point1 = value.x;
                                        var point2 = value.y;
                                        if (minimumX >= point1) {
                                            minimumX = point1;
                                        }
                                        if (minimumY >= point2) {
                                            minimumY = point2;
                                        }
                                        if (maximumX <= point1) {
                                            maximumX = point1;
                                        }
                                        if (maximumY <= point2) {
                                            maximumY = point2;
                                        }
                                    }
                                }
                                var newDifferenceX = maximumX - minimumX;
                                var newDifferenceY = maximumY - minimumY;
                                var newPoint1 = [0, 0];
                                var loadedPage = loadedDocument.getPage(pageNumber);
                                var graphics = null;
                                if (loadedPage != null) {
                                    graphics = loadedPage.graphics;
                                    graphics.save();
                                    graphics.setTransparency(opacity);
                                    graphics.translateTransform({ x: left, y: top_1 });
                                }
                                var colors = new PdfPen(color, width);
                                colors._width = this.convertPixelToPoint(thickness);
                                if (stampObjects.length > 0) {
                                    var dataPath = new PdfPath();
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var value = stampObjects[parseInt(j.toString(), 10)];
                                        var path = value.command.toString();
                                        var differenceX = ((newDifferenceX) / width);
                                        var differenceY = ((newDifferenceY) / height);
                                        var newX = ((value.x - minimumX) / differenceX);
                                        var currentY = ((value.y - minimumY) / differenceY);
                                        if (path === 'M') {
                                            if (j !== 0) {
                                                page.graphics.drawPath(dataPath, colors, null);
                                                dataPath = new PdfPath();
                                            }
                                            newPoint1 = [newX, currentY];
                                            if (!isNullOrUndefined(graphics)) {
                                                dataPath.addLine({ x: newX, y: currentY }, { x: newX, y: currentY });
                                            }
                                        }
                                        else if (path === 'L') {
                                            var newPoint2 = [newX, currentY];
                                            if (graphics != null) {
                                                // Removed this line to fix the issue EJ2-60295
                                                // graphics.DrawLine(colors, newpoint1, newpoint2);
                                                dataPath.addLine({ x: newPoint1[0], y: newPoint1[1] }, { x: newPoint2[0], y: newPoint2[1] });
                                            }
                                            newPoint1 = newPoint2;
                                        }
                                        if (j === stampObjects.length - 1) {
                                            page.graphics.drawPath(dataPath, colors, null);
                                        }
                                    }
                                }
                                if (graphics != null) {
                                    graphics.restore();
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    /**
     * @private
     * @param {string} jsonObject - jsonObject
     * @param {any} loadedDocument - loadedDocument
     * @returns {void}
     */
    SignatureBase.prototype.updateSignatureData = function (jsonObject, loadedDocument) {
        var formfields = new FormFieldsBase(this.pdfViewer, this.pdfViewerBase);
        var signatureDetails = JSON.parse(jsonObject.signatureData);
        if (!isNullOrUndefined(signatureDetails)) {
            for (var i = 0; i < signatureDetails.length; i++) {
                var pageData = signatureDetails[parseInt(i.toString(), 10)];
                // Save signature as data
                if (pageData.length > 0) {
                    for (var p = 0; p < pageData.length; p++) {
                        if (pageData[parseInt(p.toString(), 10)].status === AnnotationStatus.ExistingModified) {
                            var data = pageData[parseInt(p.toString(), 10)];
                            var signatureType = Object.prototype.hasOwnProperty.call(data, 'shapeAnnotationType') && data['shapeAnnotationType'] !== null
                                ? data['shapeAnnotationType'].toString()
                                : null;
                            if (signatureType !== null && signatureType === 'SignatureText') {
                                formfields.updateFreeTextAnnotations(data, loadedDocument, true);
                            }
                            else if (signatureType !== null && signatureType === 'SignatureImage') {
                                formfields.updateImage(data, loadedDocument, true);
                            }
                            else {
                                var pageNumber = data.pageIndex;
                                var page = loadedDocument.getPage(pageNumber);
                                var rotateAngle = this.getRotateAngle(page.rotation.toString());
                                var size = page.size;
                                var pageWidth = size.width;
                                var pageHeight = size.height;
                                if (rotateAngle === 1 || rotateAngle === 3) {
                                    pageHeight = size.width;
                                    pageWidth = size.height;
                                }
                                else {
                                    pageHeight = size.height;
                                    pageWidth = size.width;
                                }
                                var bounds = JSON.parse(data.bounds);
                                bounds = this.getSignatureBounds(bounds, this.convertPointToPixel(pageHeight), this.convertPointToPixel(pageWidth), rotateAngle);
                                var stampObjects = JSON.parse(data.data);
                                var left = this.convertPixelToPoint(bounds.left);
                                var top_2 = this.convertPixelToPoint(bounds.top);
                                var width = this.convertPixelToPoint(bounds.width);
                                var height = this.convertPixelToPoint(bounds.height);
                                var opacity = data.opacity;
                                var thickness = data.thickness;
                                var strokeColor = JSON.parse(data.strokeColor);
                                var color = { r: strokeColor.r, g: strokeColor.g, b: strokeColor.b };
                                var minimumX = -1;
                                var minimumY = -1;
                                var maximumX = -1;
                                var maximumY = -1;
                                for (var p_2 = 0; p_2 < stampObjects.length; p_2++) {
                                    var value = stampObjects[parseInt(p_2.toString(), 10)];
                                    if (minimumX === -1) {
                                        minimumX = value.x;
                                        minimumY = value.y;
                                        maximumX = value.x;
                                        maximumY = value.x;
                                    }
                                    else {
                                        var point1 = value.x;
                                        var point2 = value.y;
                                        if (minimumX >= point1) {
                                            minimumX = point1;
                                        }
                                        if (minimumY >= point2) {
                                            minimumY = point2;
                                        }
                                        if (maximumX <= point1) {
                                            maximumX = point1;
                                        }
                                        if (maximumY <= point2) {
                                            maximumY = point2;
                                        }
                                    }
                                }
                                var newDifferenceX = maximumX - minimumX;
                                var newDifferenceY = maximumY - minimumY;
                                var newPoint1 = [0, 0];
                                var loadedPage = loadedDocument.getPage(pageNumber);
                                var graphics = null;
                                if (loadedPage != null) {
                                    graphics = loadedPage.graphics;
                                    graphics.save();
                                    graphics.setTransparency(opacity);
                                    graphics.translateTransform({ x: left, y: top_2 });
                                }
                                var colors = new PdfPen(color, width);
                                colors._width = this.convertPixelToPoint(thickness);
                                if (stampObjects.length > 0) {
                                    var dataPath = new PdfPath();
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var value = stampObjects[parseInt(j.toString(), 10)];
                                        var path = value.command.toString();
                                        var differenceX = ((newDifferenceX) / width);
                                        var differenceY = ((newDifferenceY) / height);
                                        var newX = ((value.x - minimumX) / differenceX);
                                        var currentY = ((value.y - minimumY) / differenceY);
                                        if (path === 'M') {
                                            if (j !== 0) {
                                                page.graphics.drawPath(dataPath, colors, null);
                                                dataPath = new PdfPath();
                                            }
                                            newPoint1 = [newX, currentY];
                                            if (!isNullOrUndefined(graphics)) {
                                                dataPath.addLine({ x: newX, y: currentY }, { x: newX, y: currentY });
                                            }
                                        }
                                        else if (path === 'L') {
                                            var newPoint2 = [newX, currentY];
                                            if (graphics != null) {
                                                // Removed this line to fix the issue EJ2-60295
                                                // graphics.DrawLine(colors, newpoint1, newpoint2);
                                                dataPath.addLine({ x: newPoint1[0], y: newPoint1[1] }, { x: newPoint2[0], y: newPoint2[1] });
                                            }
                                            newPoint1 = newPoint2;
                                        }
                                        if (j === stampObjects.length - 1) {
                                            page.graphics.drawPath(dataPath, colors, null);
                                        }
                                    }
                                }
                                if (graphics != null) {
                                    graphics.restore();
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    /**
     * getSignatureBounds
     *
     * @param {Rect} bounds - bounds
     * @param {number} pageHeight - pageHeight
     * @param {number} pageWidth - pageWidth
     * @param {number} rotateAngle - rotateAngle
     * @returns {void}
     */
    SignatureBase.prototype.getSignatureBounds = function (bounds, pageHeight, pageWidth, rotateAngle) {
        var bound;
        if (rotateAngle === 0) {
            bound = { 'left': bounds.left, 'top': bounds.top, 'width': bounds.width, 'height': bounds.height };
        }
        else if (rotateAngle === 1) {
            bound = { 'left': (pageWidth - bounds.top - bounds.height), 'top': bounds.left, 'width': bounds.height, 'height': bounds.width };
        }
        else if (rotateAngle === 2) {
            bound = { 'left': (pageWidth - bounds.left - bounds.width), 'top': (pageHeight - bounds.top - bounds.height), 'width': bounds.width, 'height': bounds.height };
        }
        else if (rotateAngle === 3) {
            bound = { 'left': bounds.top, 'top': (pageHeight - bounds.left - bounds.width), 'width': bounds.height, 'height': bounds.width };
        }
        return bound;
    };
    /**
     * @private
     * @param {string} jsonObject - jsonObject
     * @param {any} loadedDocument - loadedDocument
     * @returns {void}
     */
    SignatureBase.prototype.saveSignatureAsAnnotatation = function (jsonObject, loadedDocument) {
        var annotationRenderer = new AnnotationRenderer(this.pdfViewer, this.pdfViewerBase);
        var signatureDetails = JSON.parse(jsonObject.signatureData);
        if (!isNullOrUndefined(signatureDetails)) {
            for (var i = 0; i < signatureDetails.length; i++) {
                var pageData = signatureDetails[parseInt(i.toString(), 10)];
                // Save signature as data
                if (pageData.length > 0) {
                    for (var p = 0; p < pageData.length; p++) {
                        if (jsonObject['action'] === 'ExportAnnotations' || pageData[parseInt(p.toString(), 10)].status === AnnotationStatus.NewlyAdded) {
                            var formfields = new FormFieldsBase(this.pdfViewer, this.pdfViewerBase);
                            var signatureAnnotation = pageData[parseInt(p.toString(), 10)];
                            var signatureType = Object.prototype.hasOwnProperty.call(signatureAnnotation, 'shapeAnnotationType') && signatureAnnotation['shapeAnnotationType'] !== null
                                ? signatureAnnotation['shapeAnnotationType'].toString()
                                : null;
                            if (signatureType !== null && signatureType === 'SignatureText') {
                                formfields.drawFreeTextAnnotations(signatureAnnotation, loadedDocument, false);
                            }
                            else if (signatureType !== null && signatureType === 'SignatureImage') {
                                formfields.drawImage(signatureAnnotation, loadedDocument, false);
                            }
                            else {
                                var bounds = JSON.parse(signatureAnnotation.bounds);
                                var stampObjects = JSON.parse(signatureAnnotation.data);
                                var pageNumber = signatureAnnotation.pageIndex;
                                var page = loadedDocument.getPage(pageNumber);
                                var cropValues = annotationRenderer.getCropBoxValue(page, false);
                                var left = cropValues.x + this.convertPixelToPoint(bounds.left);
                                var top_3 = this.convertPixelToPoint(bounds.top);
                                if (!(cropValues.x === 0 && (page.cropBox[2] === page.size.width && cropValues.y === page.size.height))) {
                                    top_3 -= cropValues.y;
                                }
                                var width = this.convertPixelToPoint(bounds.width);
                                var height = this.convertPixelToPoint(bounds.height);
                                // let cropX = 0;
                                // let cropY = 0;
                                // if(page.cropBox.x)
                                var opacity = signatureAnnotation.opacity;
                                var thickness = signatureAnnotation.thickness;
                                var strokeColor = JSON.parse(signatureAnnotation.strokeColor);
                                var color = { r: strokeColor.r, g: strokeColor.g, b: strokeColor.b };
                                var minimumX = -1;
                                var minimumY = -1;
                                var maximumX = -1;
                                var maximumY = -1;
                                var rotationAngle = annotationRenderer.getInkRotateAngle(page.rotation.toString());
                                var drawingPath = new PdfPath();
                                for (var p_3 = 0; p_3 < stampObjects.length; p_3++) {
                                    var val = stampObjects[parseInt(p_3.toString(), 10)];
                                    drawingPath.addLine({ x: val.x, y: val.y }, { x: 0, y: 0 });
                                }
                                var rotatedPath = annotationRenderer.getRotatedPathForMinMax(drawingPath._points, rotationAngle);
                                for (var k = 0; k < rotatedPath.points.length; k += 2) {
                                    var value = rotatedPath.points[parseInt(k.toString(), 10)];
                                    if (minimumX === -1) {
                                        minimumX = value[0];
                                        minimumY = value[1];
                                        maximumX = value[0];
                                        maximumY = value[1];
                                    }
                                    else {
                                        var point1 = value[0];
                                        var point2 = value[1];
                                        if (minimumX >= point1) {
                                            minimumX = point1;
                                        }
                                        if (minimumY >= point2) {
                                            minimumY = point2;
                                        }
                                        if (maximumX <= point1) {
                                            maximumX = point1;
                                        }
                                        if (maximumY <= point2) {
                                            maximumY = point2;
                                        }
                                    }
                                }
                                var newDifferenceX = (maximumX - minimumX) / width;
                                var newDifferenceY = (maximumY - minimumY) / height;
                                if (newDifferenceX === 0) {
                                    newDifferenceX = 1;
                                }
                                else if (newDifferenceY === 0) {
                                    newDifferenceY = 1;
                                }
                                var linePoints = [];
                                var isNewValues = 0;
                                if (rotationAngle !== 0) {
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var val = stampObjects[parseInt(j.toString(), 10)];
                                        var path = val['command'].toString();
                                        if (path === 'M' && j !== isNewValues) {
                                            isNewValues = j;
                                            break;
                                        }
                                        linePoints.push({
                                            x: (parseFloat(val['x'].toString())),
                                            y: (parseFloat(val['y'].toString()))
                                        });
                                    }
                                    var rotatedPoints = annotationRenderer.getRotatedPath(linePoints, rotationAngle);
                                    linePoints = [];
                                    for (var z = 0; z < rotatedPoints._points.length; z += 2) {
                                        linePoints.push({
                                            x: (rotatedPoints._points[parseInt(z.toString(), 10)].x - minimumX) / newDifferenceX + left,
                                            y: page.size.height - (rotatedPoints._points[parseInt(z.toString(), 10)].y - minimumY) /
                                                newDifferenceY - top_3
                                        });
                                    }
                                }
                                else {
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var val = stampObjects[parseInt(j.toString(), 10)];
                                        var path = val['command'].toString();
                                        if (path === 'M' && j !== isNewValues) {
                                            isNewValues = j;
                                            break;
                                        }
                                        var newX = ((val.y - minimumY) / newDifferenceY);
                                        linePoints.push({
                                            x: ((val.x - minimumX) / newDifferenceX) + left,
                                            y: page.size.height - newX - top_3
                                        });
                                    }
                                }
                                var inkAnnotation = new PdfInkAnnotation({ x: left, y: top_3, width: width, height: height }, linePoints);
                                var bound = new Rect();
                                bound = new Rect(inkAnnotation.bounds.x, (page.size.height -
                                    (inkAnnotation.bounds.y + inkAnnotation.bounds.height)), inkAnnotation.bounds.width, inkAnnotation.bounds.height);
                                inkAnnotation.bounds = bound;
                                inkAnnotation.color = color;
                                linePoints = [];
                                if (isNewValues > 0) {
                                    if (rotationAngle !== 0) {
                                        var pathCollection = [];
                                        for (var i_1 = isNewValues; i_1 < stampObjects.length; i_1++) {
                                            var val = stampObjects[parseInt(i_1.toString(), 10)];
                                            var path = val['command'].toString();
                                            if (path === 'M' && i_1 !== isNewValues) {
                                                pathCollection.push(linePoints);
                                                linePoints = [];
                                            }
                                            linePoints.push({
                                                x: val['x'],
                                                y: val['y']
                                            });
                                        }
                                        if (linePoints.length > 0) {
                                            pathCollection.push(linePoints);
                                        }
                                        for (var g = 0; g < pathCollection.length; g++) {
                                            var graphicsPoints = [];
                                            var pointsCollections = pathCollection[parseInt(g.toString(), 10)];
                                            if (pointsCollections.length > 0) {
                                                var rotatedPoints = annotationRenderer.getRotatedPath(pointsCollections, rotationAngle);
                                                for (var z = 0; z < rotatedPoints._points.length; z += 2) {
                                                    graphicsPoints.push({
                                                        x: (rotatedPoints._points[parseInt(z.toString(), 10)].x - minimumX) /
                                                            newDifferenceX + left,
                                                        y: page.size.height -
                                                            (rotatedPoints._points[parseInt(z.toString(), 10)].y - minimumY) /
                                                                newDifferenceY - top_3
                                                    });
                                                }
                                                inkAnnotation.inkPointsCollection.push(graphicsPoints);
                                            }
                                            graphicsPoints = [];
                                        }
                                    }
                                    else {
                                        for (var i_2 = isNewValues; i_2 < stampObjects.length; i_2++) {
                                            var val = stampObjects[parseInt(i_2.toString(), 10)];
                                            var path = val['command'].toString();
                                            if (path === 'M' && i_2 !== isNewValues) {
                                                inkAnnotation.inkPointsCollection.push(linePoints);
                                                linePoints = [];
                                            }
                                            var newX = ((val['y'] - minimumY) / newDifferenceY);
                                            linePoints.push({
                                                x: (val['x'] - minimumX) / newDifferenceX + left,
                                                y: page.size.height - newX - top_3
                                            });
                                        }
                                        if (linePoints.length > 0) {
                                            inkAnnotation.inkPointsCollection.push(linePoints);
                                        }
                                    }
                                }
                                inkAnnotation.border.width = thickness;
                                inkAnnotation.opacity = opacity;
                                inkAnnotation._dictionary.set('NM', signatureAnnotation.signatureName.toString());
                                inkAnnotation._annotFlags = PdfAnnotationFlag.print;
                                if (Object.prototype.hasOwnProperty.call(signatureAnnotation, 'author') && signatureAnnotation['author'] !== null) {
                                    var author = signatureAnnotation['author'].toString();
                                    if (author !== 'Guest') {
                                        inkAnnotation.author = author;
                                    }
                                }
                                page.annotations.add(inkAnnotation);
                            }
                        }
                    }
                }
            }
        }
    };
    /**
     * @private
     * @param {string} jsonObject - jsonObject
     * @param {any} loadedDocument - loadedDocument
     * @returns {void}
     */
    SignatureBase.prototype.updateSignatureAsAnnotatation = function (jsonObject, loadedDocument) {
        var annotationRenderer = new AnnotationRenderer(this.pdfViewer, this.pdfViewerBase);
        var signatureDetails = JSON.parse(jsonObject.signatureData);
        if (!isNullOrUndefined(signatureDetails)) {
            for (var i = 0; i < signatureDetails.length; i++) {
                var pageData = signatureDetails[parseInt(i.toString(), 10)];
                // Save signature as data
                if (pageData.length > 0) {
                    for (var p = 0; p < pageData.length; p++) {
                        if (pageData[parseInt(p.toString(), 10)].status === AnnotationStatus.ExistingModified) {
                            var formfields = new FormFieldsBase(this.pdfViewer, this.pdfViewerBase);
                            var signatureAnnotation = pageData[parseInt(p.toString(), 10)];
                            var signatureType = Object.prototype.hasOwnProperty.call(signatureAnnotation, 'shapeAnnotationType') && signatureAnnotation['shapeAnnotationType'] !== null
                                ? signatureAnnotation['shapeAnnotationType'].toString()
                                : null;
                            if (signatureType !== null && signatureType === 'SignatureText') {
                                formfields.updateFreeTextAnnotations(signatureAnnotation, loadedDocument, false);
                            }
                            else if (signatureType !== null && signatureType === 'SignatureImage') {
                                formfields.updateImage(signatureAnnotation, loadedDocument, false);
                            }
                            else {
                                var bounds = JSON.parse(signatureAnnotation.bounds);
                                var stampObjects = JSON.parse(signatureAnnotation.data);
                                var annotationIndex = signatureAnnotation.annotationIndex;
                                var pageNumber = signatureAnnotation.pageIndex;
                                var page = loadedDocument.getPage(pageNumber);
                                var annotation = page.annotations.at(annotationIndex);
                                var cropValues = annotationRenderer.getCropBoxValue(page, false);
                                var left = cropValues.x + this.convertPixelToPoint(bounds.left);
                                var top_4 = this.convertPixelToPoint(bounds.top);
                                if (!(cropValues.x === 0 && (page.cropBox[2] === page.size.width && cropValues.y === page.size.height))) {
                                    top_4 -= cropValues.y;
                                }
                                var width = this.convertPixelToPoint(bounds.width);
                                var height = this.convertPixelToPoint(bounds.height);
                                // let cropX = 0;
                                // let cropY = 0;
                                // if(page.cropBox.x)
                                var opacity = signatureAnnotation.opacity;
                                var thickness = signatureAnnotation.thickness;
                                var strokeColor = JSON.parse(signatureAnnotation.strokeColor);
                                var color = { r: strokeColor.r, g: strokeColor.g, b: strokeColor.b };
                                var minimumX = -1;
                                var minimumY = -1;
                                var maximumX = -1;
                                var maximumY = -1;
                                var rotationAngle = annotationRenderer.getInkRotateAngle(page.rotation.toString());
                                var drawingPath = new PdfPath();
                                for (var p_4 = 0; p_4 < stampObjects.length; p_4++) {
                                    var val = stampObjects[parseInt(p_4.toString(), 10)];
                                    drawingPath.addLine({ x: val.x, y: val.y }, { x: 0, y: 0 });
                                }
                                var rotatedPath = annotationRenderer.getRotatedPathForMinMax(drawingPath._points, rotationAngle);
                                for (var k = 0; k < rotatedPath.points.length; k += 2) {
                                    var value = rotatedPath.points[parseInt(k.toString(), 10)];
                                    if (minimumX === -1) {
                                        minimumX = value[0];
                                        minimumY = value[1];
                                        maximumX = value[0];
                                        maximumY = value[1];
                                    }
                                    else {
                                        var point1 = value[0];
                                        var point2 = value[1];
                                        if (minimumX >= point1) {
                                            minimumX = point1;
                                        }
                                        if (minimumY >= point2) {
                                            minimumY = point2;
                                        }
                                        if (maximumX <= point1) {
                                            maximumX = point1;
                                        }
                                        if (maximumY <= point2) {
                                            maximumY = point2;
                                        }
                                    }
                                }
                                var newDifferenceX = (maximumX - minimumX) / width;
                                var newDifferenceY = (maximumY - minimumY) / height;
                                if (newDifferenceX === 0) {
                                    newDifferenceX = 1;
                                }
                                else if (newDifferenceY === 0) {
                                    newDifferenceY = 1;
                                }
                                var linePoints = [];
                                var isNewValues = 0;
                                if (rotationAngle !== 0) {
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var val = stampObjects[parseInt(j.toString(), 10)];
                                        var path = val['command'].toString();
                                        if (path === 'M' && j !== isNewValues) {
                                            isNewValues = j;
                                            break;
                                        }
                                        linePoints.push({
                                            x: (parseFloat(val['x'].toString())),
                                            y: (parseFloat(val['y'].toString()))
                                        });
                                    }
                                    var rotatedPoints = annotationRenderer.getRotatedPath(linePoints, rotationAngle);
                                    linePoints = [];
                                    for (var z = 0; z < rotatedPoints._points.length; z += 2) {
                                        linePoints.push({
                                            x: (rotatedPoints._points[parseInt(z.toString(), 10)].x - minimumX) / newDifferenceX + left,
                                            y: page.size.height - (rotatedPoints._points[parseInt(z.toString(), 10)].y - minimumY) /
                                                newDifferenceY - top_4
                                        });
                                    }
                                }
                                else {
                                    for (var j = 0; j < stampObjects.length; j++) {
                                        var val = stampObjects[parseInt(j.toString(), 10)];
                                        var path = val['command'].toString();
                                        if (path === 'M' && j !== isNewValues) {
                                            isNewValues = j;
                                            break;
                                        }
                                        var newX = ((val.y - minimumY) / newDifferenceY);
                                        linePoints.push({
                                            x: ((val.x - minimumX) / newDifferenceX) + left,
                                            y: page.size.height - newX - top_4
                                        });
                                    }
                                }
                                if (annotation instanceof PdfInkAnnotation) {
                                    var inkAnnotation = annotation;
                                    inkAnnotation.bounds = { x: left, y: top_4, width: width, height: height };
                                    inkAnnotation._points = linePoints;
                                    var x = inkAnnotation.bounds.x;
                                    var y = (page.size.height - (inkAnnotation.bounds.y + inkAnnotation.bounds.height));
                                    var inkWidth = inkAnnotation.bounds.width;
                                    var inkHeight = inkAnnotation.bounds.height;
                                    inkAnnotation.bounds = { x: x, y: y, width: inkWidth, height: inkHeight };
                                    inkAnnotation.color = color;
                                    linePoints = [];
                                    if (isNewValues > 0) {
                                        if (rotationAngle !== 0) {
                                            var pathCollection = [];
                                            for (var i_3 = isNewValues; i_3 < stampObjects.length; i_3++) {
                                                var val = stampObjects[parseInt(i_3.toString(), 10)];
                                                var path = val['command'].toString();
                                                if (path === 'M' && i_3 !== isNewValues) {
                                                    pathCollection.push(linePoints);
                                                    linePoints = [];
                                                }
                                                linePoints.push(val['x']);
                                                linePoints.push(val['y']);
                                            }
                                            if (linePoints.length > 0) {
                                                pathCollection.push(linePoints);
                                            }
                                            for (var g = 0; g < pathCollection.length; g++) {
                                                var graphicsPoints = [];
                                                var pointsCollections = pathCollection[parseInt(g.toString(), 10)];
                                                if (pointsCollections.length > 0) {
                                                    var rotatedPoints = annotationRenderer.getRotatedPath(pointsCollections, rotationAngle);
                                                    for (var z = 0; z < rotatedPoints._points.length; z += 2) {
                                                        graphicsPoints.push({
                                                            x: (rotatedPoints._points[parseInt(z.toString(), 10)].x - minimumX) /
                                                                newDifferenceX + left,
                                                            y: page.size.height - (rotatedPoints._points[parseInt(z.toString(), 10)].y
                                                                - minimumY) / newDifferenceY - top_4
                                                        });
                                                    }
                                                    inkAnnotation.inkPointsCollection.push(graphicsPoints);
                                                }
                                                graphicsPoints = [];
                                            }
                                        }
                                        else {
                                            for (var i_4 = isNewValues; i_4 < stampObjects.length; i_4++) {
                                                var val = stampObjects[parseInt(i_4.toString(), 10)];
                                                var path = val['command'].toString();
                                                if (path === 'M' && i_4 !== isNewValues) {
                                                    inkAnnotation.inkPointsCollection.push(linePoints);
                                                    linePoints = [];
                                                }
                                                var newX = ((val['y'] - minimumY) / newDifferenceY);
                                                linePoints.push({
                                                    x: (val['x'] - minimumX) / newDifferenceX + left,
                                                    y: page.size.height - newX - top_4
                                                });
                                            }
                                            if (linePoints.length > 0) {
                                                inkAnnotation.inkPointsCollection.push(linePoints);
                                            }
                                        }
                                    }
                                    inkAnnotation.border.width = thickness;
                                    inkAnnotation.opacity = opacity;
                                    inkAnnotation._dictionary.set('NM', signatureAnnotation.signatureName.toString());
                                    inkAnnotation._annotFlags = PdfAnnotationFlag.print;
                                    if (Object.prototype.hasOwnProperty.call(signatureAnnotation, 'author') && signatureAnnotation['author'] !== null) {
                                        var author = signatureAnnotation['author'].toString();
                                        if (author !== 'Guest') {
                                            inkAnnotation.author = author;
                                        }
                                    }
                                    inkAnnotation._dictionary._updated = true;
                                }
                            }
                        }
                    }
                }
            }
        }
    };
    SignatureBase.prototype.convertPointToPixel = function (number) {
        return number * 96 / 72;
    };
    SignatureBase.prototype.convertPixelToPoint = function (value) {
        return (value * (72 / 96));
    };
    SignatureBase.prototype.getRotateAngle = function (angleString) {
        var angle = 0;
        switch (angleString) {
            case 'RotateAngle0':
            case '0':
                angle = 0;
                break;
            case 'RotateAngle180':
            case '2':
                angle = 2;
                break;
            case 'RotateAngle270':
            case '3':
                angle = 3;
                break;
            case 'RotateAngle90':
            case '1':
                angle = 1;
                break;
        }
        return angle;
    };
    return SignatureBase;
}());
export { SignatureBase };
